import { render } from "./StaffInfo.vue?vue&type=template&id=e7e146e8&scoped=true"
import script from "./StaffInfo.vue?vue&type=script&lang=js"
export * from "./StaffInfo.vue?vue&type=script&lang=js"

import "./StaffInfo.vue?vue&type=style&index=0&id=e7e146e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7e146e8"]])

export default __exports__